// ============================================================
// customer-excel.js
// ------------------------------------------------------------
// ข้อกำหนดของไฟล์ Excel "นำเข้าข้อมูลลูกค้า" (import_customer.xlsx)
// ใช้ร่วมกัน 2 หน้า: หน้า Customer (popup นำเข้า) และหน้า ImportCustomer (นำเข้าเต็มหน้าจอ)
//
// เดิมทั้งสองหน้าเก็บรายชื่อหัวคอลัมน์และตารางแปลงค่าไว้คนละชุด
// ถ้าไฟล์ template เปลี่ยนแล้วแก้แค่หน้าเดียว อีกหน้าจะรับไฟล์ไม่ได้ทันที
// ============================================================

// ชื่อชีตในไฟล์ template — ถ้าไม่ตรงชื่อนี้ ระบบจะไม่รับไฟล์
export const CUSTOMER_SHEET_NAME = "นำเข้าข้อมูลลูกค้า";

// หัวคอลัมน์ตามลำดับในไฟล์ template (ต้องตรงเป๊ะทั้งชื่อและลำดับ)
export const CUSTOMER_COLUMNS = [
  "ชื่อ - สกุล",
  "เลขบัตรประชาชน",
  "ที่อยู่",
  "โทรศัพท์บ้าน",
  "โทรศัพท์มือถือ",
  "วันที่ส่งมอบ(ช่องกรอก)",
  "วันที่ส่งมอบ",
  "วันที่มารับมอบ(ช่องกรอก)",
  "วันที่มารับมอบ",
  "วันที่โอน(ช่องกรอก)",
  "วันที่โอน",
  "สถานะการโอน",
  "เลขที่เงินกู้",
  "วงเงินกู้",
  "เงินงวด",
  "วันที่ทำสัญญา(ช่องกรอก)",
  "วันที่ทำสัญญา",
  "ซื้ออาคารโดย",
  "อาคาร",
  "ชั้น",
  "บ้านเลขที่",
  "ขนาดห้อง (ตรม.)",
];

// สถานะการโอนกรรมสิทธิ์ — ข้อความในไฟล์ Excel ↔ รหัสที่ backend เก็บ
export const TRANSFER_FROM_TEXT = { โอนกรรมสิทธิ์แล้ว: 1, ยังไม่โอนกรรมสิทธิ์: 2, ห้องว่าง: 3 };

// วิธีการซื้ออาคาร — ข้อความในไฟล์ Excel ↔ รหัสที่ backend เก็บ
// (ไม่มี "การเคหะแห่งชาติ" = 6 เพราะไฟล์ template ไม่รองรับค่านี้)
export const BUY_FROM_TEXT = { เงินสด: 1, ผ่อนชำระกับธนาคาร: 2, ผู้เช่าซื้อกับการเคหะแห่งชาติ: 3, ซื้อต่อกับลูกค้าเดิม: 4, "อื่น ๆ": 5 };

// แปลงรหัสกลับเป็นข้อความ (ใช้ตอนแสดงตารางตัวอย่างก่อนนำเข้า)
export const transferText = (value) => Object.keys(TRANSFER_FROM_TEXT).find((k) => TRANSFER_FROM_TEXT[k] === value) || "-";
export const buyText = (value) => Object.keys(BUY_FROM_TEXT).find((k) => BUY_FROM_TEXT[k] === value) || "-";

// ตรวจหัวคอลัมน์ของชีตที่ผู้ใช้อัปโหลดมา
// คืนชื่อคอลัมน์แรกที่ไม่ตรง หรือ null ถ้าถูกต้องทั้งหมด
export const findInvalidColumn = (sheetHeaderRow, columns = CUSTOMER_COLUMNS) => {
  const index = columns.findIndex((col, i) => sheetHeaderRow[i] !== col);
  return index > -1 ? columns[index] : null;
};

// เติม 0 นำหน้าให้ครบหลัก — Excel มักตัด 0 นำหน้าของเลขบัตร/เบอร์มือถือทิ้ง
export const padLeftDigits = (value, length) => (value ? ("0".repeat(length) + value).slice(-length) : "");
